import { isMobile as isUaMobile } from "@/utils/UserAgentUtil";
import { isOnHybridApp } from "@/utils/MobileHybridApplication";

/**
 * 모바일인 경우 첫번째 값을, 모바일이 아닌경우 오른쪽 값을 리턴한다.
 * @param v1
 * @param v2
 */
export function mlnr(v1, v2) {
  return isOnHybridApp() ? v1 : isUaMobile() ? v1 : v2;
}
